











import Vue from 'vue';
import BbTools from '@/tools/bluebird';
import { Lang } from '@/store/types';

export default Vue.extend({
  props: {
    lang: {
      type: Object as () => Lang,
    },
    size: Number,
  },
  computed: {
    sizeComputed(): number {
      return this.size || 25;
    },
    langIconSrc(): string | null {
      if (this.lang) {
        return `${this.$store.getters.URL_FLAGS}${BbTools.getILangAsLLang(this.lang.id)}.jpg${BbTools.APP_POSTFIX}`;
      }
      return null;
    },
  },
});
